type ComponentIdProps = {
  id?: string;
  requestedId?: string;
};

const ProductComponentId = ({ id, requestedId }: ComponentIdProps): JSX.Element | null => {
  return (
    <div className='flex flex-column justify-content-center'>
      <div className='font-normal max-w-fit'>{id}</div>

      {requestedId && (
        <div className='white-space-nowrap overflow-hidden text-overflow-ellipsis w-full font-normal font-italic text-gray-600 line-height-2'>
          {requestedId}
        </div>
      )}
    </div>
  );
};

export default ProductComponentId;
